// eslint-disable-next-line react-hooks/exhaustive-deps
import { Button, Card, Result, Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Title } from '../../components';
import LogosEmpresaAseguradora from '../../components/LogosEmpresaAseguradora';
import StepperSolicitud from '../../components/StepperSolicitud';
import {
  SiniestroProvider,
  useSiniestroContext
} from '../../context/siniestro-context';
import { SolicitudProvider } from '../../context/solicitud-context';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import ConfirmarDatos from './ConfirmarDatos';
import Confirmar from './steps/Confirmar';
import DatosAccidente from './steps/DatosAccidente';
import Involucrados from './steps/Involucrados';

const SiniestroProv = () => (
  <SolicitudProvider>
    <SiniestroProvider>
      <SiniestroForm />
    </SiniestroProvider>
  </SolicitudProvider>
);

export default SiniestroProv;

const stepsVehiculo = [
  {
    title: 'Paso 1',
    description: (
      <span>
        Datos del <strong>accidente</strong>
      </span>
    )
  },
  {
    title: 'Paso 2',
    description: (
      <span>
        Personas <strong>Involucradas</strong>
      </span>
    )
  },
  {
    title: 'Paso 3',
    description: (
      <span>
        Confirmación de <strong>datos</strong>
      </span>
    )
  }
];

const steps = [
  {
    title: 'Paso 1',
    description: (
      <span>
        Datos del <strong>accidente</strong>
      </span>
    )
  },
  {
    title: 'Paso 2',
    description: (
      <span>
        Confirmación de <strong>datos</strong>
      </span>
    )
  }
];

function SiniestroForm() {
  const {
    datosSiniestro,
    setDatosSiniestro,
    loading,
    setLoading,
    datosAsegurado,
    setDatosAsegurado
  } = useSiniestroContext();
  const myRef = useRef(null);
  const { token } = useParams();
  const [current] = useState(0);
  const [step, setStep] = useState(0);
  const [datosIngresados, setDatosIngresados] = useState({});
  const [landing, setLanding] = useState(false);

  const handleSetDatosIngresados = (values) => {
    setDatosIngresados(values);
  };

  const stepPagesVehiculo = [
    <DatosAccidente
      setStep={setStep}
      datosIngresados={datosIngresados}
      handleSetDatosIngresados={handleSetDatosIngresados}
    />,
    <Involucrados
      current={1}
      setStep={setStep}
      datosIngresados={datosIngresados}
      handleSetDatosIngresados={handleSetDatosIngresados}
    />,
    <Confirmar
      setStep={setStep}
      current={2}
      datosIngresados={datosIngresados}
      handleSetDatosIngresados={handleSetDatosIngresados}
    />
  ];

  const stepPages = [
    <DatosAccidente
      setStep={setStep}
      datosIngresados={datosIngresados}
      handleSetDatosIngresados={handleSetDatosIngresados}
    />,
    <Confirmar
      setStep={setStep}
      current={1}
      datosIngresados={datosIngresados}
      handleSetDatosIngresados={handleSetDatosIngresados}
    />
  ];

  useEffect(() => {
    const getSiniestroData = () => {
      setLoading(true);
      instanceRef.instance
        .get(`/siniestro/${token}`)
        .then((res) => {
          setDatosSiniestro(res.data.data);
          setDatosAsegurado(res.data.data.poliza);
          setLoading(false);
        })
        .catch((err) => {
          errorHandler(err, err.message);
        });
    };
    getSiniestroData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LogosEmpresaAseguradora />
      <Card style={{ margin: '20px' }}>
        {landing &&
          datosSiniestro &&
          datosSiniestro.estado === 'DENUNCIA' &&
          datosSiniestro.etapa === 'PENDIENTE' && (
            <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
              {datosAsegurado && (
                <>
                  <Title stlye={{ marginBottom: '10px' }}>
                    Denuncia de Siniestro
                  </Title>
                  <ConfirmarDatos title="Detalle de datos" contacto={false} />
                  <div style={{ marginTop: '10px' }}>
                    <Button type="primary" onClick={() => setLanding(false)}>
                      Iniciar
                    </Button>
                  </div>
                </>
              )}
            </Spin>
          )}
        {!landing &&
          datosAsegurado &&
          datosSiniestro.estado === 'DENUNCIA' &&
          datosSiniestro.etapa === 'PENDIENTE' && (
            <div>
              <div ref={myRef} />
              {current !== steps.length - 1 && (
                <Title stlye={{ marginBottom: '10px' }}>
                  Denuncia de Siniestro
                </Title>
              )}

              {datosAsegurado.producto.codigo === 1 && (
                <>
                  {step !== 2 && (
                    <StepperSolicitud
                      current={step}
                      steps={
                        datosAsegurado.producto.codigo === 1
                          ? stepsVehiculo.slice(0, 6)
                          : steps.slice(0, 6)
                      }
                    />
                  )}
                  {stepPagesVehiculo[step]}
                </>
              )}
              {datosAsegurado.producto.codigo !== 1 && (
                <>
                  {step !== 1 && (
                    <StepperSolicitud
                      current={step}
                      steps={
                        datosAsegurado.producto.codigo === 1
                          ? stepsVehiculo.slice(0, 6)
                          : steps.slice(0, 6)
                      }
                    />
                  )}
                  {stepPages[step]}
                </>
              )}
            </div>
          )}
        {datosSiniestro &&
          (datosSiniestro.etapa === 'PENDIENTE_FIRMA' ||
            datosSiniestro.etapa === 'FIRMADA') && (
            <Result
              status="success"
              title="¡El Siniestro ya está en proceso de firma!"
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => {
                    window.location.href = `/`;
                  }}
                >
                  Ir al inicio
                </Button>
              ]}
            />
          )}
        {datosSiniestro &&
          (datosSiniestro.etapa === 'FOTOS_SUBIDAS' ||
            datosSiniestro.etapa === 'AMPLIACION_FINALIZADA' ||
            datosSiniestro.etapa === 'FINALIZADA' ||
            datosSiniestro.etapa === 'VERIFICAR') && (
            <Result
              status="warning"
              title="¡Acción no permitida!"
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => {
                    window.location.href = `/siniestros`;
                  }}
                >
                  Volver al listado
                </Button>
              ]}
            />
          )}
      </Card>
    </>
  );
}
